import { Component, Input, inject } from '@angular/core';
import { Anlagentyp } from '../../../domain/model/anlagentyp';
import { AnlagentypColorService } from '../../../service/anlagentyp/anlagentyp-color.service';
import { RoutingService } from '../../../service/common/routing/routing.service';
import { AnlagentypIconService } from '../../../service/anlagentyp/anlagentyp-icon.service';
import { environment } from '../../../../environments/environment';
import { InstallierteLeistungAggregate } from '../../../domain/model/report/installierte-leistung-aggregate';
import { Leistungseinheit } from '../../../domain/model/leistungseinheit';

@Component({
    selector: 'tnb-aggregation-tile',
    templateUrl: './aggregation-tile.component.html',
    styleUrls: [
        './aggregation-tile.component.scss',
    ],
    standalone: false,
})
export class AggregationTileComponent {
    private anlagetypColorService = inject(AnlagentypColorService);
    private anlagentypIconService = inject(AnlagentypIconService);
    routingService = inject(RoutingService);


    @Input()
    public aggregation: InstallierteLeistungAggregate;

    @Input()
    public leistungseinheit?: Leistungseinheit = null;

    public ASSET_URL = environment.ASSET_URL;

    public get tileColorName(): string {
        return this.anlagetypColorService.getColorNameForAnlagentyp(this.aggregation.anlagentyp);
    }

    public get tileIconName(): string {
        return this.anlagentypIconService.getIconNameForAnlagentyp(this.aggregation.anlagentyp);
    }

    public get anlagentype(): Anlagentyp {
        return this.aggregation.anlagentyp;
    }
}
